import React from 'react';
import './App.css';
import './lib/ripple.min.css';
import './tachyons.min.css';
import AxL from "./lib/axl.js";
import Intro from './Components/Intro';
import Game from './Components/Game';
import End from './Components/End';
import Share from "./Components/Share"
import LandscapeWarning from './Components/LandscapeWarning';
import Spinner from './Components/Spinner';

// Translations
import en from "./data/translations/en.json";
const supportedLanguages =  {
  'en': en,
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gameStartMs: 0,
      lang: "en",
      screen: null,
      totalScore: 0,
      category: null,
      params: null,
      mapsLoaded: false,
      isFetchingData: false,
      currRound: 0,
      gameName: "standard",
      isInLine: false,
    };
    // https://cilex-geo-artwork.appspot.com/geo-artwork
    // Use a relative URL to avoid CORS errors
    this.apiURL = "/geo-artwork/api/";

    if (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"
    ) {
      this.apiURL = "http://localhost:8080/geo-artwork/api/";
    }

    this.setScreen = this.setScreen.bind(this);
    this.registerScore = this.registerScore.bind(this);
    this.resetGame = this.resetGame.bind(this);
    this.registerEndGame = this.registerEndGame.bind(this);
    this.openLink = this.openLink.bind(this);
    this.pickData = this.pickData.bind(this);
    this.share = this.share.bind(this);
    this.registerMapsLoaded = this.registerMapsLoaded.bind(this);
    this.track = this.track.bind(this);
    this.registerRound = this.registerRound.bind(this);
    this.data = null;
    this.categoryData = null;
    this.gameData = {};
    this.numrounds = 5;
    this.numCat = 6;
    this.axl = null;
  }

  componentDidMount() {
    this.initAxl();
    this.warmUpServer();
  }

  initAxl() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.setLang(urlParams);
    this.setRTL(urlParams);
    this.axl = urlParams.get("optout") ? null : new AxL();
    if (this.axl) {
      this.axl.handshake().then((params) => {
        // console.log("params are: ", params);
        // this.axl.storage.getHighScore().then((highScore)=>{console.log("high score is", highScore);})
        // if it's an inlineGame
        let isInLine = this.state.isInLine;
        // get the inline param from the url param
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const inline = urlParams.get("inline");
        if (inline) {
          isInLine = inline;
        }
        if (params.score) {
          // if it's a special game
          const gameName = params.sharedGameName;
          if (gameName !== "standard") {
            this.setState({ score: params.score, isInLine: isInLine });
            this.getDataForSpecialGame(params.ids, params.sharedGameName);
          } else {
            // else
            this.setState({ score: params.score, isInLine: isInLine });
            this.getData(params.ids);
          }
        } else if (params.ids) {
          // console.log("lets display the game with given ids", params.ids);
          this.getData(params.ids);
        } else if (params.game_name) {
          const sheetId = params.game_name;
          this.setState({ gameName: params.game_name, isInLine: isInLine });
          this.getSheet(sheetId);
        } else {
          this.setState({
            screen: "intro",
            isInLine: isInLine,
          });
        }
        // console.log("isInline=", isInLine);
        // if (!this.data) this.initData();
      });
    } /*else {
      if (!this.data) this.initData();
    }*/
  }

  warmUpServer() {
    // console.log("fetching, ", this.apiURL + "category/wakeup");
    fetch(this.apiURL + "category/wakeup").then((response) => {
      if (response.status === "200") {
      }
      // else {
      //   console.log("API responded with status code", response.status);
      // }
    });
  }

  getSheet(sheetName) {
    // console.log("get sheet ", sheetName);
    const url = this.apiURL + "sheet/" + sheetName;
    // console.log("url=", url);
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data["error"]) {
          this.setState({
            screen: "intro",
          });
        } else {
          // console.log("got data", data);
          this.gameData = data.data;
          this.setState({
            screen: "game",
          });
        }
      });
  }

  getDataForSpecialGame(ids, sheetName) {
    let stringIds;
    if (Array.isArray(ids)) {
      stringIds = ids.join();
    } else {
      stringIds = ids;
    }
    const url = this.apiURL + "idsforsheet/" + stringIds + "/" + sheetName;
    // console.log('url=', url)
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data["error"]) {
          this.setState({
            screen: "intro",
          });
        } else {
          this.gameData = data.data;
          if (this.state.score) {
            this.setScreen("share");
          } else {
            this.setState({
              screen: "game",
            });
          }
        }
      });
  }

  getData(ids) {
    // if ids is an array:
    // ["0AHqEQI6E1xX2w","4wEJxmTlawgtVA","bQFJops3-GwN9Q","jAGgOt8XRK11-g","2AFENOi3JBVnug"]
    // else, if it's a string, eg:
    //  '0AHqEQI6E1xX2w,4wEJxmTlawgtVA,bQFJops3-GwN9Q,jAGgOt8XRK11-g,2AFENOi3JBVnug'
    // ?cp=eyJpZHMiOiIwQUhxRVFJNkUxeFgydyw0d0VKeG1UbGF3Z3RWQSxiUUZKb3BzMy1Hd045USxqQUdnT3Q4WFJLMTEtZywyQUZFTk9pM0pCVm51ZyJ9
    let stringIds;
    // console.log("get data for ids", ids);
    if (Array.isArray(ids)) {
      stringIds = ids.join();
    } else {
      stringIds = ids;
    }

    const url = this.apiURL + "ids/" + stringIds;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // console.log("got data", data);
        this.gameData = data.data;
        if (this.state.score) {
          this.setScreen("share");
        } else {
          this.setState({
            screen: "game",
          });
        }
      });
  }

  setRTL(params) {
    let rtl = params.get("rtl") || "0";
    this.setState({
      rtl: rtl,
    });
    console.log("RTL set to", rtl);
  }

  setLang(params) {
    let lang = params.get("lang") || "en";
    if (!(lang in supportedLanguages)) lang = "en";
    this.setState({
      lang: lang,
    });
    // console.log("language set to", lang);
  }

  pickData(category) {
    // console.log("fetching, ", this.apiURL + "category/" + category);
    const url = this.apiURL + "category/" + category;
    this.setState({ isFetchingData: true });
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.setState({ isFetchingData: false });
        const secureGameData = this.replaceHttpByHttps(data.data);
        this.gameData = secureGameData;
        this.setScreen("game", category);
      });
  }

  replaceHttpByHttps(data) {
    data.forEach((item) => {
      item.thumbnail = item.thumbnail.replace("http://", "https://");
    });
    return data;
  }

  //["0AHqEQI6E1xX2w","4wEJxmTlawgtVA","bQFJops3-GwN9Q","jAGgOt8XRK11-g","2AFENOi3JBVnug"]
  resetGame(isEnd = false) {
    this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {});
    const payload = {
      action: "click start again",
      label: this.state.category,
    };
    if (isEnd) payload.action = "click play again";
    this.track(payload);
    this.data = null;
    this.gameData = {};
    this.setState({
      screen: "intro",
      totalScore: 0,
      category: null,
      score: null,
      currRound: 0,
    });
  }

  openLink(assetUrl) {
    if (this.axl) this.axl.sendMessage(AxL.ChildToHost.NAVIGATE, assetUrl);
    const payload = {
      action: "click asset link",
      label: "/" + assetUrl,
    };
    this.track(payload);
  }

  registerHighScore(pts) {
    if (this.axl) {
      this.axl.storage
        .setHighScore(pts)
        .then(() => {})
        .catch((error) => {
          // console.log(error);
        });
    }
  }

  registerEndGame() {
    this.registerHighScore(this.state.totalScore);
    const now = new Date().getTime();
    const elapsedTime = now - this.state.gameStartMs;
    const payload = {
      action: `game end-${this.state.totalScore}`,
      label: this.state.category,
      value: elapsedTime,
    };
    this.track(payload);
  }

  setScreen(screen, category = null) {
    if (this.axl) {
      if (screen === "game") {
        const payload = {
          action: "game start",
          label: category,
        };
        this.track(payload);

        if (category != null) {
          // register the game start time
          const now = new Date().getTime();
          this.setState({ gameStartMs: now });
        }
      }
    }
    this.setState({
      screen: screen,
      category: category,
    });
  }

  registerScore(score) {
    const newScore = score + this.state.totalScore;
    this.setState({
      totalScore: newScore,
      hasGuessedAtLeastOnce: true,
    });
    const payload = {
      action: "click guess",
      label: this.state.category,
      value: this.state.currRound + 1,
    };
    this.track(payload);
  }

  share() {
    if (this.axl) {
      // console.log(this.gameData);
      const ids = [];
      this.gameData.forEach((item) => {
        ids.push(item.id);
      });
      // console.log("ids=", ids);

      const score = this.state.totalScore;
      this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
        score: score,
        ids: ids,
        sharedGameName: this.state.gameName,
      });

      const shareText = supportedLanguages[this.state.lang]["share_text"];
      // console.log("shareText", shareText);
      this.axl.sendMessage(AxL.ChildToHost.SHARE, {
        title: shareText,
      });

      const payload = {
        action: "click share your score",
        label: this.state.category,
      };
      this.track(payload);
    }
  }

  registerMapsLoaded() {
    // console.log("registerMapsLoaded");
    this.setState({ mapsLoaded: true });
  }

  track(payload, additionalInfo = null) {
    if (this.axl) {
      if (additionalInfo) {
        if (additionalInfo === "category") payload.label = this.state.category;
      }
      this.axl.sendMessage(AxL.ChildToHost.TRACK, payload);
    }
  }

  registerRound(round) {
    // console.log("register next round!");
    this.setState({ currRound: round });
    const payload = {
      action: "click next round",
      label: this.state.category,
    };
    this.track(payload);
  }

  render() {
    const screen = this.state.screen;
    return (
      <div className="w-100 h-100">
        {/* Spinner */}
        {this.state.isFetchingData ? (
          <Spinner i18n={supportedLanguages[this.state.lang]} />
        ) : null}
        {/* Rotation warning */}
        <LandscapeWarning i18n={supportedLanguages[this.state.lang]} />
        {/* Share */}
        {screen === "share" ? (
          <Share
            i18n={supportedLanguages[this.state.lang]}
            score={this.state.score}
            resetGame={this.resetGame}
            gameData={this.gameData}
          />
        ) : null}
        {/* Intro */}
        {screen === "intro" ? (
          <Intro
            i18n={supportedLanguages[this.state.lang]}
            pickData={this.pickData}
          />
        ) : null}

        {/* Game Screen */}
        {screen === "game" ? (
          <Game
            i18n={supportedLanguages[this.state.lang]}
            setScreen={this.setScreen}
            category={this.state.category}
            rtl={this.state.rtl}
            totalScore={this.state.totalScore}
            gameData={this.gameData}
            registerScore={this.registerScore}
            resetGame={this.resetGame}
            registerEndGame={this.registerEndGame}
            openLink={this.openLink}
            isInLine={this.state.isInLine}
            share={this.share}
            track={this.track}
            registerRound={this.registerRound}
            isMapLoaded={this.state.registerMapsLoaded}
            registerMapsLoaded={this.registerMapsLoaded}
            mapsLoaded={this.state.mapsLoaded}
            hasGuessedAtLeastOnce={this.state.hasGuessedAtLeastOnce}
          />
        ) : null}

        {/* End Screen */}
        {screen === "end" ? (
          <End
            setScreen={this.setScreen}
            i18n={supportedLanguages[this.state.lang]}
          />
        ) : null}
      </div>
    );
  }
}

export default App;



